import {Link, usePage} from '@inertiajs/react';
import imgUrl from '../../images/logo-t.png'

export default function NavbarGuest() {
    const appName = import.meta.env.VITE_APP_NAME;
    return (
        <div className="z-70 px-10 py-5 sticky from-2% left-0 top-0 w-full bg-gradient-to-r from-primary to-primary-400 to-127% flex items-center">
            <Link href="/" className="inline-block mr-3 logo-img">
                <img className="object-contain h-8 w-auto max-w-32 md:max-w-none" src={imgUrl} />
            </Link>
            <span className="text-white font-bold text-base">{appName} - {usePage().props.appLabel}</span>
        </div>
    );
}
